"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _generalStore = require("general-store");

var _immutable = require("immutable");

var _hasSfdcSyncEnabledDependency = _interopRequireDefault(require("crm_ui/flux/dependencies/hasSfdcSyncEnabledDependency"));

var _UserSettingsKeys = _interopRequireDefault(require("crm_data/settings/UserSettingsKeys"));

var _UserSettingsStore = _interopRequireDefault(require("crm_data/settings/UserSettingsStore"));

var _SidebarIntegrationsStore = _interopRequireDefault(require("crm_data/integrations/SidebarIntegrationsStore"));

var _DealRenewalPipelineDependency = _interopRequireDefault(require("crm_ui/BET/deals/DealRenewalPipelineDependency"));

var _BETPartnerCollabDependancy = _interopRequireDefault(require("crm_ui/BET/deals/BETPartnerCollabDependancy"));

var _dealSourceDependency = _interopRequireDefault(require("crm_ui/flux/dependencies/dealSourceDependency"));

var _LoadingStatus = require("crm_data/flux/LoadingStatus");

var _filter = _interopRequireDefault(require("transmute/filter"));

var _get = _interopRequireDefault(require("transmute/get"));

var _pipe = _interopRequireDefault(require("transmute/pipe"));

var _sortBy = _interopRequireDefault(require("transmute/sortBy"));

var _toJS = _interopRequireDefault(require("transmute/toJS"));

var _partial = _interopRequireDefault(require("transmute/partial"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UserSettingsActions = require("crm_data/settings/UserSettingsActions");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _CardsLayout = _interopRequireDefault(require("customer-data-sidebar/CardsLayout"));

var _SidebarQuery = _interopRequireDefault(require("customer-data-sidebar/graphQL/SidebarQuery"));

var _sidebarIntegrationTypes = _interopRequireDefault(require("crm_ui/constants/sidebarIntegrationTypes"));

var _IntegrationsActionForm = _interopRequireDefault(require("crm_ui/profile/sidebar/contacts/IntegrationsActionForm"));

var _ProfileIntegrationsLinkedSalesObjectContainer = _interopRequireDefault(require("crm_ui/profile/sidebar/integrations/ProfileIntegrationsLinkedSalesObjectContainer"));

var _PreviewSidebarAsync = _interopRequireDefault(require("crm_ui/async/sidebar/PreviewSidebarAsync"));

var _links = _interopRequireDefault(require("crm_internal/config/links"));

var _InteractionTypes = require("customer-data-communicator/schema/interactions/InteractionTypes");

var _tracker2 = require("customer-data-tracking/tracker");

var _events = require("customer-data-sidebar/tracking/events");

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _userInfo = _interopRequireDefault(require("hub-http/userInfo"));

var _SettingsStore = _interopRequireDefault(require("crm_data/settings/SettingsStore"));

var _PortalSettingsKeys = _interopRequireDefault(require("crm_data/constants/PortalSettingsKeys"));

var _isTrue = _interopRequireDefault(require("crm_ui/utils/isTrue"));

var _AccountingExtensionsStore = _interopRequireDefault(require("crm_data/accounting/stores/AccountingExtensionsStore"));

var _PropertySourceTypes = require("customer-data-objects/property/PropertySourceTypes");

var Alerts = _interopRequireWildcard(require("customer-data-ui-utilities/alerts/Alerts"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _IsUngatedStore = _interopRequireDefault(require("crm_data/gates/IsUngatedStore"));

var _getIsUngatedForGraphQL = require("crm_ui/gates/getIsUngatedForGraphQL");

var _LinkedSalesObjectTitle = _interopRequireDefault(require("../components/profile/sidebar/LinkedSalesObjectTitle"));

var _IntegrationsContents, _IntegrationsTitles;

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  &&& {\n    min-width: 316px;\n    width: 25vw !important;\n    max-width: 477px;\n\n    @media screen and (min-width: 1920px) {\n      min-width: 476px;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var RightSidebar = (0, _styledComponents.default)(_PreviewSidebarAsync.default).withConfig({
  displayName: "CardsSidebar__RightSidebar",
  componentId: "b8seyu-0"
})(_templateObject());

var getClosedCardKey = function getClosedCardKey(objectType) {
  return _UserSettingsKeys.default["PROFILE_SIDEBAR_" + objectType];
};

var getIntegrationCardKey = function getIntegrationCardKey(module) {
  if (module.get('type') === _sidebarIntegrationTypes.default.ACTION_FORM) {
    return "int-form-" + module.get('formId');
  }

  return "int-obj-" + module.get('objectTypeId');
};

var IntegrationsContents = (_IntegrationsContents = {}, (0, _defineProperty2.default)(_IntegrationsContents, _sidebarIntegrationTypes.default.ACTION_FORM, function IntegrationsActionFormContainer(_ref) {
  var isEditable = _ref.isEditable,
      module = _ref.module,
      subjectId = _ref.subjectId;
  return _react.default.createElement(_IntegrationsActionForm.default, {
    actionForm: module,
    contactId: +subjectId,
    isEditable: isEditable
  });
}), (0, _defineProperty2.default)(_IntegrationsContents, _sidebarIntegrationTypes.default.LINKED_SALES_OBJECT, function ProfileIntegrationsLinkedSalesObject(_ref2) {
  var module = _ref2.module,
      objectType = _ref2.objectType,
      subjectId = _ref2.subjectId;
  return _react.default.createElement(_ProfileIntegrationsLinkedSalesObjectContainer.default, {
    linkedSalesObject: module,
    associatedObjectId: +subjectId,
    associatedObjectType: objectType
  });
}), _IntegrationsContents);
var IntegrationsTitles = (_IntegrationsTitles = {}, (0, _defineProperty2.default)(_IntegrationsTitles, _sidebarIntegrationTypes.default.ACTION_FORM, function ActionFormTitle(_ref3) {
  var module = _ref3.module;
  return _react.default.createElement("span", null, module.get('appName'));
}), (0, _defineProperty2.default)(_IntegrationsTitles, _sidebarIntegrationTypes.default.LINKED_SALES_OBJECT, function LinkedSalesObjectTitleRenderer(_ref4) {
  var module = _ref4.module,
      subjectId = _ref4.subjectId,
      objectType = _ref4.objectType;
  return _react.default.createElement(_LinkedSalesObjectTitle.default, {
    linkedSalesObject: module,
    associatedObjectId: subjectId,
    associatedObjectType: objectType
  });
}), _IntegrationsTitles);
var dependencies = {
  accountingExtensions: _AccountingExtensionsStore.default,
  hasSfdc: _hasSfdcSyncEnabledDependency.default,
  closedCardsSetting: {
    stores: [_UserSettingsStore.default],
    deref: function deref(_ref5) {
      var objectType = _ref5.objectType;
      return _UserSettingsStore.default.get(getClosedCardKey(objectType));
    }
  },
  hasSalesNavigatorInstalled: {
    stores: [_UserSettingsStore.default],
    deref: function deref() {
      var hasSalesNavigatorInstalled = _UserSettingsStore.default.get(_UserSettingsKeys.default.LINKEDIN_SALES_NAVIGATOR);

      if (hasSalesNavigatorInstalled === _LoadingStatus.LOADING) {
        return _LoadingStatus.LOADING;
      }

      return hasSalesNavigatorInstalled;
    }
  },
  integrationModules: {
    stores: [_SidebarIntegrationsStore.default],
    deref: function deref(_ref6) {
      var objectType = _ref6.objectType;
      return _SidebarIntegrationsStore.default.get(objectType);
    }
  },
  isUngatedForGraphQL: {
    stores: [_IsUngatedStore.default],
    deref: function deref(_ref7) {
      var objectType = _ref7.objectType;
      return (0, _getIsUngatedForGraphQL.getIsUngatedForGraphQL)(objectType);
    }
  },
  isRenewalDeal: _DealRenewalPipelineDependency.default,
  isPartnerCollabDeal: _BETPartnerCollabDependancy.default,
  dealSource: _dealSourceDependency.default,
  isGdprComplianceEnabled: {
    stores: [_SettingsStore.default],
    deref: function deref() {
      return _SettingsStore.default.get() && (0, _isTrue.default)(_SettingsStore.default.get().get(_PortalSettingsKeys.default.GDPR_COMPLIANCE_ENABLED));
    }
  }
};

var isVisibleFor = function isVisibleFor(props) {
  return function (_ref8) {
    var condition = _ref8.condition;
    return typeof condition !== 'function' || condition(props);
  };
};

var isAlert = function isAlert(_ref9) {
  var Title = _ref9.Title;
  return !Title;
};

var isCard = function isCard(_ref10) {
  var Title = _ref10.Title;
  return Title;
};

var CardsSidebar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(CardsSidebar, _Component);

  function CardsSidebar(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CardsSidebar);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CardsSidebar).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      previewId: undefined,
      previewObjectType: undefined,
      showPreview: false,
      layout: null
    };
    return _this;
  }

  (0, _createClass2.default)(CardsSidebar, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      (0, _userInfo.default)().then(function (user) {
        _this2.setState({
          auth: user
        });
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_ref11, _ref12) {
      var isRightSidebarCollapsed = _ref11.isRightSidebarCollapsed,
          sortOrder = _ref11.sortOrder,
          showIntegrationCards = _ref11.showIntegrationCards,
          isEditable = _ref11.isEditable,
          integrationModules = _ref11.integrationModules,
          hasSalesNavigatorInstalled = _ref11.hasSalesNavigatorInstalled,
          hasSfdc = _ref11.hasSfdc,
          isRenewalDeal = _ref11.isRenewalDeal,
          isDirectSalesDeal = _ref11.isDirectSalesDeal,
          closedCardsSetting = _ref11.closedCardsSetting,
          isGdprComplianceEnabled = _ref11.isGdprComplianceEnabled,
          accountingExtensions = _ref11.accountingExtensions,
          layout = _ref11.layout;
      var showPreview = _ref12.showPreview,
          previewId = _ref12.previewId,
          auth = _ref12.auth;
      return this.props.layout !== layout || this.state.showPreview !== showPreview || this.state.previewId !== previewId || this.props.isRightSidebarCollapsed !== isRightSidebarCollapsed || this.props.sortOrder !== sortOrder || this.props.showIntegrationCards !== showIntegrationCards || this.props.isEditable !== isEditable || !this.state.auth && !!auth || (this.props.integrationModules || (0, _immutable.List)()).size !== (integrationModules || (0, _immutable.List)()).size || this.props.hasSalesNavigatorInstalled !== hasSalesNavigatorInstalled || this.props.hasSfdc !== hasSfdc || this.props.isRenewalDeal !== isRenewalDeal || this.props.isDirectSalesDeal !== isDirectSalesDeal || !this.props.closedCardsSetting && !!closedCardsSetting || this.props.closedCardsSetting !== closedCardsSetting || this.props.isGdprComplianceEnabled !== isGdprComplianceEnabled || this.props.accountingExtensions !== accountingExtensions || !this.state.auth && !!auth;
    }
  }, {
    key: "getClosedCards",
    value: function getClosedCards() {
      var closedCardsSetting = this.props.closedCardsSetting;

      if (!(0, _LoadingStatus.isResolved)(closedCardsSetting)) {
        return [];
      }

      return (0, _pipe.default)(_toJS.default, (0, _filter.default)((0, _get.default)('collapsed')), Object.keys)(closedCardsSetting);
    }
  }, {
    key: "getLayout",
    value: function getLayout() {
      var layout = this.props.layout;

      if (this.props.namespace === 'UISidebarCards_RIGHT') {
        layout = (0, _immutable.Seq)(layout).filter(function (item) {
          return item.key !== 'Properties';
        }).toArray();
      }

      return layout;
    }
  }, {
    key: "getInternalCards",
    value: function getInternalCards() {
      var _this3 = this;

      var _this$props = this.props,
          onCommunicatorClick = _this$props.onCommunicatorClick,
          apiCardsData = _this$props.cardsData,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["onCommunicatorClick", "cardsData"]);
      var cardTypes = this.getLayout().filter(isVisibleFor(this.props)).filter(isCard).reduce(function (cardsMap, card) {
        cardsMap[card.key] = (0, _extends2.default)({
          Actions: card.Toolbar
        }, card);
        return cardsMap;
      }, {});
      var communicatorProps = onCommunicatorClick && {
        onEmailClick: (0, _partial.default)(onCommunicatorClick, _InteractionTypes.EMAIL, this.state.previewObjectType, this.state.previewId),
        onPhoneClick: (0, _partial.default)(onCommunicatorClick, _InteractionTypes.CALL, this.state.previewObjectType, this.state.previewId)
      };
      var typesList = Object.keys(cardTypes);
      var cardsData = typesList.reduce(function (cardsMap, cardType) {
        cardsMap[cardType] = (0, _extends2.default)({
          onPreviewRecord: _this3.handlePreviewAssociation
        }, communicatorProps, {
          apiData: apiCardsData[cardType]
        }, rest);
        return cardsMap;
      }, {});
      return [cardTypes, cardsData];
    }
  }, {
    key: "getIntegrationCards",
    value: function getIntegrationCards() {
      var _this4 = this;

      var _this$props$integrati = this.props.integrationModules,
          integrationModules = _this$props$integrati === void 0 ? [] : _this$props$integrati;
      var cardTypes = integrationModules.reduce(function (cardsMap, module) {
        cardsMap[getIntegrationCardKey(module)] = {
          Content: IntegrationsContents[module.get('type')],
          indentation: 'compact',
          Title: IntegrationsTitles[module.get('type')]
        };
        return cardsMap;
      }, {});
      var cardsData = integrationModules.reduce(function (cardsMap, module) {
        cardsMap[getIntegrationCardKey(module)] = (0, _extends2.default)({}, _this4.props, {
          module: module
        });
        return cardsMap;
      }, {});
      return [cardTypes, cardsData];
    }
  }, {
    key: "handlePreviewAssociation",
    value: function handlePreviewAssociation(previewId, previewObjectType) {
      this.setState({
        previewId: previewId,
        previewObjectType: previewObjectType,
        showPreview: true
      });
      (0, _events.trackOpenSidebar)(_tracker2._tracker, {
        type: previewObjectType
      });
    }
  }, {
    key: "handleClosePreview",
    value: function handleClosePreview() {
      this.setState({
        previewId: undefined,
        previewObjectType: undefined,
        showPreview: false
      });
    }
  }, {
    key: "handleClosedCardsChange",
    value: function handleClosedCardsChange(newClosedCards) {
      var closedCardsSetting = this.props.closedCardsSetting;
      var objectType = this.props.objectType;
      var currentClosedCards = this.getClosedCards();
      var toggledCard;

      if (newClosedCards.length > currentClosedCards.length) {
        toggledCard = (0, _filter.default)(function (type) {
          return currentClosedCards.indexOf(type) === -1;
        }, newClosedCards)[0];
      } else {
        toggledCard = (0, _filter.default)(function (type) {
          return newClosedCards.indexOf(type) === -1;
        }, currentClosedCards)[0];
      }

      if (!(0, _LoadingStatus.isResolved)(closedCardsSetting)) {
        closedCardsSetting = (0, _immutable.Map)();
      }

      if (toggledCard) {
        var toggleCardKeyPath = [toggledCard, 'collapsed'];
        var toggledCollapsed = !closedCardsSetting.getIn(toggleCardKeyPath);
        (0, _UserSettingsActions.saveUserSetting)(getClosedCardKey(objectType), closedCardsSetting.setIn(toggleCardKeyPath, toggledCollapsed));
      }
    }
  }, {
    key: "handleObjectCreate",
    value: function handleObjectCreate(_ref13) {
      var associationType = _ref13.associationType;
      return Alerts.addSuccess("createObjectModal.createSuccess." + associationType);
    }
  }, {
    key: "handleCommunicatorClickFromPreviewSidebar",
    value: function handleCommunicatorClickFromPreviewSidebar(interactionType, objectType, subjectId, propertyName) {
      this.props.onCommunicatorClick(interactionType, this.state.previewObjectType, this.state.previewId, objectType, subjectId, propertyName);
    }
  }, {
    key: "renderPreviewSidebar",
    value: function renderPreviewSidebar() {
      var PreviewHighlight = this.props.PreviewHighlight;
      var _this$state = this.state,
          previewId = _this$state.previewId,
          previewObjectType = _this$state.previewObjectType;
      if (!previewId && !previewObjectType) return undefined;

      var recordHref = _links.default.fromObjectTypeAndId(previewObjectType, previewId);

      return _react.default.createElement(RightSidebar, {
        CustomHighlight: PreviewHighlight,
        onPreviewAssociation: this.handlePreviewAssociation,
        objectType: previewObjectType,
        onClose: this.handleClosePreview,
        onCommunicatorClick: this.handleCommunicatorClickFromPreviewSidebar,
        recordHref: recordHref,
        subjectId: previewId
      });
    }
  }, {
    key: "renderCardLayout",
    value: function renderCardLayout(isCompact) {
      var _this5 = this;

      var _this$getInternalCard = this.getInternalCards(),
          _this$getInternalCard2 = (0, _slicedToArray2.default)(_this$getInternalCard, 2),
          internalCardTypes = _this$getInternalCard2[0],
          internalCardsData = _this$getInternalCard2[1];

      var cardTypes = Object.assign({}, internalCardTypes);
      var cardsData = Object.assign({}, internalCardsData);

      if (this.props.showIntegrationCards) {
        var _this$getIntegrationC = this.getIntegrationCards(),
            _this$getIntegrationC2 = (0, _slicedToArray2.default)(_this$getIntegrationC, 2),
            integrationCardTypes = _this$getIntegrationC2[0],
            integrationCardsData = _this$getIntegrationC2[1];

        Object.assign(cardTypes, integrationCardTypes);
        Object.assign(cardsData, integrationCardsData);
      }

      var closedCards = this.getClosedCards();
      var usedTypes = Object.keys(cardTypes);
      var orderedUsedCards = (0, _sortBy.default)(function (type) {
        return (0, _get.default)(type, _this5.props.sortOrder);
      }, usedTypes).filter(function (card) {
        return card;
      });
      var CardsLayout = this.props.isUngatedForGraphQL ? _SidebarQuery.default : _CardsLayout.default;
      return _react.default.createElement(CardsLayout, {
        auth: this.state.auth,
        additionalCardTypes: cardTypes,
        canAddObjects: this.props.isEditable,
        cardsData: cardsData,
        cardTypes: {},
        closedCards: closedCards,
        compact: isCompact,
        CustomHighlight: function CustomHighlight() {
          return null;
        },
        enableDnD: true,
        isUngatedForGraphQL: this.props.isUngatedForGraphQL,
        namespace: this.props.namespace,
        objectType: this.props.objectType,
        onClosedCardsChange: this.handleClosedCardsChange,
        onObjectCreate: this.handleObjectCreate,
        onOrderChange: this.props.onOrderChange,
        sortOrder: orderedUsedCards,
        sourceApp: _PropertySourceTypes.CRM_UI,
        subjectId: this.props.subjectId,
        tracker: _tracker2._tracker
      });
    }
  }, {
    key: "render",
    value: function render() {
      var transferrableProps = (0, _extends2.default)({}, this.props);
      var showPreview = this.state.showPreview;
      var alerts = this.getLayout().filter(isAlert).filter(isVisibleFor(this.props));
      var previewSidebar = showPreview && this.renderPreviewSidebar();

      if (!alerts.length) {
        return _react.default.createElement("div", null, previewSidebar, this.renderCardLayout(true));
      }

      return _react.default.createElement("div", null, previewSidebar, _react.default.createElement(_UIList.default, {
        className: "p-top-4 p-right-4 p-left-4",
        childClassName: "m-bottom-4"
      }, alerts.map(function (_ref14) {
        var CardComponent = _ref14.Content,
            key = _ref14.key;
        return _react.default.createElement(CardComponent, (0, _extends2.default)({
          key: key
        }, transferrableProps));
      })), this.renderCardLayout(false));
    }
  }]);
  return CardsSidebar;
}(_react.Component);

CardsSidebar.propTypes = {
  PreviewHighlight: _propTypes.default.func,
  accountingExtensions: _reactImmutableProptypes.default.list,
  cardsData: _propTypes.default.object,
  closedCardsSetting: _propTypes.default.object,
  hasSalesNavigatorInstalled: _propTypes.default.bool,
  hasSfdc: _propTypes.default.bool,
  integrationModules: _reactImmutableProptypes.default.list,
  isEditable: _propTypes.default.bool,
  isDirectSalesDeal: _propTypes.default.bool,
  isGdprComplianceEnabled: _propTypes.default.bool,
  isRenewalDeal: _propTypes.default.bool,
  isRightSidebarCollapsed: _propTypes.default.bool,
  isUngatedForGraphQL: _propTypes.default.bool,
  layout: _propTypes.default.array,
  namespace: _propTypes.default.string,
  objectType: _ObjectTypesType.default.isRequired,
  onCommunicatorClick: _propTypes.default.func,
  onOrderChange: _propTypes.default.func.isRequired,
  showIntegrationCards: _propTypes.default.bool,
  sortOrder: _propTypes.default.instanceOf(_immutable.Map),
  subjectId: _propTypes.default.string
};
CardsSidebar.defaultProps = {
  cardsData: {}
};

var _default = (0, _generalStore.connect)(dependencies)(CardsSidebar);

exports.default = _default;
module.exports = exports.default;